import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { config } from '@uhg-abyss/web/tools/config';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Link } from '@uhg-abyss/web/ui/Link';
import React from 'react';

/**
 * ViewSharePoint
 *
 * @TODO Needs description.
 *
 * @param currentEntity
 * @param exportDetails
 * @returns {Element}
 * @constructor
 */
export function ViewSharePoint({ currentEntity = {}, exportDetails = {} }) {
  const sharePointEnvironments = {
    dev: 'remhub-dev',
    local: 'remhub-dev',
    'local:build': 'remhub-dev',
    'local:dev': 'remhub-dev',
    prod: 'remhub',
    stage: 'remhub-stg',
  };

  const sharePointDirectoryUrl = `https://uhgazure.sharepoint.com/teams/RemHubReports/Shared%20Documents/General/${encodeURIComponent(
    `${sharePointEnvironments[config('APP_ENV')]}/${currentEntity?.name}`
  )}`;

  const isDisabled = exportDetails?.status === 'exported';

  return (
    <ErrorHandler location="src/features/Risk/components/tables/RiskRecords/components/Header/components/ViewSharePoint/ViewSharePoint.jsx">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        before={
          <IconSymbol
            color={isDisabled ? 'var(--abyss-colors-gray5)' : 'var(--abyss-colors-interactive1)'}
            icon="visibility"
          />
        }
        hideIcon
        href={sharePointDirectoryUrl}
        isDisabled={isDisabled}
        onClick={(event) => {
          if (isDisabled) {
            event?.preventDefault();
          }
        }}
        openNewWindow
      >
        View on SharePoint
      </Link>
    </ErrorHandler>
  );
}
